import classNames from "classnames";

export const ItemSkeleton = ({ index }) => {
  return (
    <div
      className={classNames(
        "border-2 border-solid border-white rounded-[40px] p-[24px] pt-[40px] mb-[24px] relative btn-item",
        index % 3 === 0 ? "ml-0" : "ml-[24px]"
      )}
      style={{ width: "calc((100% - 48px) / 3)" }}
    >
      <div className="h-[112px]">
        <div className="font-black text-[24px] leading-[28px] mb-[8px] line-clamp-1 bg-[#18191c] h-[28px]"></div>

        <div className="text-[14px] font-normal leading-[22px] line-clamp-2 h-[44px] bg-[#18191c]"></div>
      </div>

      <div className="mt-[16px] mb-[24px]">
        <div className="aspect-w-1 aspect-h-1 relative bg-[#18191c]"></div>
      </div>
    </div>
  );
};
